import { UserApi } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { getAppFlow } from '../utils/user-profile.util';

export async function getUserProfileProducts(productId: string) {
  const url = new URL(UserApi.getProducts + productId);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Flow: getAppFlow(),
      },
    })
  );
}
